


















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'lodash-decorators';
import axios from 'axios';
import { api } from '@/api';
import { Family } from '@/interfaces/Models';
import { BalancePackage } from '@/interfaces/Models';
import FamilyAutocomplete from '@/components/dashboard/admin/family/FamilyAutocomplete.vue';
import { Action, Getter } from 'vuex-class';

@Component
export default class BalanceForm extends Vue {
  public balanceType: string = '';
  public expandPackage: boolean = false;
  public expandHours: boolean = false;
  public expandEuros: boolean = false;
  public recalculateBalance: boolean = false;

  public changeBalanceType(value: any) {
    this.expandPackage = this.isPackage;
    this.expandHours = this.isHours;
    this.expandEuros = this.isEuros;
  }

  public get isPackage() {
    return this.balanceType == 'package';
  }
  public get isHours() {
    return this.balanceType == 'hours';
  }
  public get isEuros() {
    return this.balanceType == 'euros';
  }

  public tab: any = null;
  public get tabs(): any[] {
    return [
      {
        title: this.$t('families.add-balance.package.title'),
        value: 'package',
        icon: 'mdi-package-variant-closed',
      },
      {
        title: this.$t('families.add-balance.hours.title'),
        value: 'hours',
        icon: 'mdi-clock-outline',
      },
      {
        title: this.$t('families.add-balance.euros.title'),
        value: 'euros',
        icon: 'mdi-currency-eur',
      },
    ];
  }
  public family: any = null;

  public familyRules: ((v: any) => void)[] = [
    (v: Family) => !!v || 'Family is required',
  ];
  public families: Family[] = [];
  public familyName: any = null;
  public familyLoading: boolean = false;

  public balancePackage: BalancePackage = {
    id: 0,
    name: '',
    cost: 0,
    minutes: 0,
    hours: 0,
    price_per_hours: 0,
    recalculate_balance: false,
  };

  public balancePackageRules: ((v: BalancePackage) => void)[] = [
    (v: BalancePackage) => !!v.id || 'Balance Package is Required',
  ];

  public balancePackages: BalancePackage[] = [];
  public balancePackagesLoaded: boolean = true;

  public hours: number = 0;
  public minHours: number = 1;
  public maxHours: number = 20;
  public hoursRules: ((v: any) => void)[] = [
    (v) =>
      v >= this.minHours /* && v <= this.maxHours */ ||
      'Invalid amount of hours.',
  ];

  public euros: number = 0;
  public minEuros: number = 1;
  public eurosRules: ((v: number) => void)[] = [
    (v) => v >= this.minEuros || 'Invalid amount of euros.',
  ];

  public parentShiftId: number | null = null;
  public transactionSubtype: string | null = null;

  public note: string = '';

  public addPackage: boolean = true;

  public getAddPackageBool(): boolean {
    return this.addPackage;
  }
  public $refs!: {
    // fix for this.$refs.form.valdiate(); TS error
    package: HTMLFormElement;
    hours: HTMLFormElement;
    euros: HTMLFormElement;
  };

  public async getBalancePackages() {
    let packages = await axios
      .get(api.path('v1.admin.packages'))
      .then((response) => response.data.data);

    this.balancePackages = packages.filter((single: any) => single.cost);

    this.balancePackagesLoaded = false;
  }

  public submit(): void {
    if (!this.$refs.package.validate()) return;

    let data!: {
      path: string;
      payload: {};
    };

    if (this.isPackage) {
      data = this.packagePayload();
    } else if (this.isHours) {
      data = this.hoursPayload();
    } else if (this.isEuros) {
      data = this.eurosPayload();
    } else {
      return;
    }

    axios.post(data.path, data.payload).then((res) => {
      this.$toast.success(res.data.message);
      this.$refs.package.reset();
    });
  }

  public submitHours(): void {
    if (!this.$refs.hours.validate()) return;

    let data = this.hoursPayload();

    axios.post(data.path, data.payload).then((res) => {
      this.$toast.success(res.data.message);
      this.$refs.hours.reset();
    });
  }

  public submitEuros(): void {
    if (!this.$refs.euros.validate()) return;

    let data = this.eurosPayload();

    axios.post(data.path, data.payload).then((res) => {
      this.$toast.success(res.data.message);
      this.$refs.euros.resetValidation();
    });
  }

  public packagePayload() {
    return {
      path: api.path('v1.admin.families.createTransaction', {
        id: this.family.id,
      }),
      payload: {
        balance_type: 'package',
        transaction_type: 1,
        balance_package_id: this.balancePackage.id,
        recalculate_balance: this.recalculateBalance,
      },
    };
  }

  public hoursPayload() {
    return {
      path: api.path('v1.admin.families.createTransaction', {
        id: this.family.id,
      }),
      payload: {
        balance_type: 'hours',
        transaction_type: 1,
        amount: this.hours,
        parent_shift_id: this.parentShiftId,
        transaction_subtype: this.transactionSubtype,
        note: this.note,
      },
    };
  }

  public eurosPayload() {
    return {
      path: api.path('v1.admin.families.createTransaction', {
        id: this.family.id,
      }),
      payload: {
        balance_type: 'money',
        transaction_type: 1,
        amount: this.euros,
        parent_shift_id: this.parentShiftId,
        transaction_subtype: this.transactionSubtype,
        note: this.note,
      },
    };
  }

  @Watch('familyName')
  @Debounce(500)
  onFamilyNameChange(value: string): void {
    let params = {
      paginate: 'no',
      family: value,
    };
    this.familyLoading = true;

    if (value === null) {
      this.familyLoading = false;
      this.families = [];
      return;
    }

    axios.get(api.path('v1.admin.families'), { params: params }).then((res) => {
      this.familyLoading = false;
      this.families = res.data.data;
    });
  }

  @Action('transactionSubtypes/fetch') fetchTransactionSubtypes: any;
  @Getter('transactionSubtypes/transacitonSubtypes') transactionSubtypes: any;

  public transactionSubtypeReadable(subtype: any) {
    return this.$t(`transaction_subtype.${subtype.value}`);
  }

  public mounted(): void {
    this.fetchTransactionSubtypes();

    this.getBalancePackages();
  }
}
